<template>
    <div class="fab-preview">
        <span class="title">{{ $t("fastWizard.preview") }}</span>
        <div class="content">
            <div class="fab-items" :class="{ iconMode: fabIconActive }">
                <div
                    class="fab-item-preview"
                    :class="{
                        [metas[fab.type].colorClass]: true,
                        disabled: !fabs[i].enable || !isFabsActive,
                        iconMode: !fabIconActive,
                    }"
                    v-model="fabs[i]"
                    v-for="(fab, i) of fabs"
                    :key="fab.type"
                >
                    <div class="fab-icon">
                        <img v-show="true" :src="`/static/img/fabImages/${fab.type}Icon.svg`" class="fab-icon" />
                    </div>
                    <div class="text">
                        {{ metas[fab.type].title }}
                    </div>
                </div>
            </div>
            <div class="bubble-preview-wrapper">
                <BubblePreview width="50px" height="50px" />
            </div>
        </div>
    </div>
</template>

<script>
import BubblePreview from "../../../../components/fast-initialize/BubblePreview.vue";
import { mapState } from "vuex";
import _ from "lodash";
import FabItem from "./FabItem.vue";

export default {
    name: "FabPreview",
    components: { FabItem, BubblePreview },
    data() {
        return {
            metas: {
                live: {
                    title: this.$t(`message.liveFabListDescription`),
                    colorClass: "orange",
                },
                ticket: {
                    title: this.$t(`message.ticketFabListDescription`),
                    colorClass: "blue",
                },
                whatsapp: {
                    title: this.$t(`message.whatsappFabListDescription`),
                    colorClass: "whatsapp",
                },
                phone: {
                    title: this.$t(`message.phoneFabListDescription`),
                    colorClass: "phone",
                },
                email: {
                    title: this.$t(`message.emailFabListDescription`),
                    colorClass: "mail",
                },
                facebook: {
                    title: this.$t(`message.facebookFabListDescription`),
                    colorClass: "blue",
                },
                twitter: {
                    title: this.$t(`message.twitterFabListDescription`),
                    colorClass: "teal",
                },
                instagram: {
                    title: this.$t(`message.instagramFabListDescription`),
                    colorClass: "instagram",
                },
                youtube: {
                    title: this.$t(`message.youtubeFabListDescription`),
                    colorClass: "orange",
                },
                linkedin: {
                    title: this.$t(`message.linkedinFabListDescription`),
                    colorClass: "blue",
                },
                telegram: {
                    title: this.$t(`message.telegramFabListDescription`),
                    colorClass: "teal",
                },
            },
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            isDarkMode: (state) => state.darkMode,
            fabIconActive: (state) => _.get(state.setting.settings, "fab.isFabsAsIcon"),
            isFabsActive: (state) => _.get(state.setting.settings, "fab.isFabsActive"),
        }),
        fabs: {
            get() {
                return _.get(this.settings, "fab.items", []);
            },
            set(value) {
                this.updateSettings("fab.items", value);
            },
        },
        isFabsAsIcon: {
            get() {
                return _.get(this.settings, "fab.isFabsAsIcon");
            },
            set(value) {
                this.updateSettings("fab.isFabsAsIcon", value);
            },
        },
    },
};
</script>

<style scoped lang="scss">
.fab-preview {
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    padding-left: 0;
    position: relative;
    width: 100%;
    background-image: url(data:image/gif;base64,R0lGODlhEAAQAJEAAAAAAP////X19f///yH5BAEAAAMALAAAAAAQABAAAAIflG+hq4jM3IFLJhqswNly/XkcBpIiVaInlLJr9FZWAQA7);

    background-repeat: repeat;
    height: 100%;

    .title {
        font-size: 20px;
        font-weight: 400;
        line-height: 20px;
        color: var(--color-text-strong-default);
        letter-spacing: 5px;
        padding: 5px;
    }

    .content {
        display: flex;
        flex-direction: column;
        max-width: 130px;
        gap: 5px;
        position: absolute;
        bottom: 0;
        right: 0;
    }

    .fab-items {
        display: flex;
        flex-direction: column;
        gap: 3px;

        &.iconMode {
            justify-content: flex-end;
            align-items: center;
        }
    }

    .fab-item-preview {
        box-shadow: 2px 2px 7px 0 #00000047;
        border-radius: 8px;
        padding: 3px 5px;
        width: 125px;
        height: 35px;
        display: flex;
        gap: 3px;
        align-items: center;
        user-select: none;
        cursor: pointer;

        &.iconMode {
            width: 30px;
            justify-content: flex-end;
            align-items: center;

            .text {
                display: none;
            }
        }

        &.disabled {
            display: none;
        }

        &:hover {
            box-shadow: 2px 2px 7px 0 #00000047;
        }

        .fab-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 !important;

            img {
                width: 20px !important;
                height: 20px !important;
            }
        }

        .text {
            color: var(--color-text-onghost-default);
            font-size: 12px;
            font-weight: 700;
            line-height: 12px;
            letter-spacing: 0em;
        }

        &.orange {
            background-color: rgb(236, 75, 29);
        }

        &.blue {
            background-color: rgb(21, 34, 92);
        }

        &.teal {
            background-color: rgb(103, 150, 255);
        }

        &.red {
            background-color: #ec3131;
        }

        &.whatsapp {
            background-color: rgb(128, 186, 107);
        }

        &.phone {
            background-color: rgb(103, 150, 255);
        }

        &.mail {
            background-color: rgb(251, 188, 5);
        }

        &.instagram {
            background: linear-gradient(90deg, #f9b035 0%, #f98c4e 53%, #cc4a89 100%);
        }
    }

    .bubble-preview-wrapper {
        display: flex;
        justify-content: flex-end;

        .bubble-preview {
            img {
                width: 50px !important;
                height: 50px !important;
            }
        }
    }
}
</style>
